<app-breadcrumb *ngIf="!embeddedView"  [master]="'Należności'" [parentName]="'Należności'" [name]="'Lista'"></app-breadcrumb>
<div class="receivables-import-row-list-container">
  <form *ngIf="showFilter" (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-import-row-list-filters">

    <app-dict-insurance-companies
      [multiple]="true" label="TU"
      class="receivables-import-row-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
    ></app-dict-insurance-companies>

    <app-dict
      [multiple]="true" label="Importer"
      class="receivables-import-row-list-filter"
      [dictType]="'receivables_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.importer" name="importer"
    ></app-dict>

    <app-dict
      [multiple]="false" label="Firma"
      class="receivables-import-row-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-partners
      *ngIf="!embeddedView"
      [multiple]="false" label="Partner"
      class="receivables-import-row-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <mat-form-field
      *ngIf="!embeddedView"
      class="receivables-import-row-list-filter">
      <mat-label>Numer umowy</mat-label>
      <input matInput placeholder="Numer umowy" name="contractNumber" [(ngModel)]="initialFilters.contractNumber">
    </mat-form-field>

    <app-dict-regionals
      *ngIf="!embeddedView"
      [multiple]="false" label="Regionalny majątek (Partner)"
      class="receivables-import-row-list-filter"
      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"
    ></app-dict-regionals>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="receivables-import-row-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
     ></app-dict-ofwcas>

    <mat-form-field
      *ngIf="!embeddedView"
      class="receivables-import-row-list-filter">
      <mat-label>Numer RAU</mat-label>
      <input matInput placeholder="Numer RAU" name="rauNumber" [(ngModel)]="initialFilters.rauNumber">
    </mat-form-field>

    <mat-form-field class="receivables-import-row-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="containsFromLeft$policyNumber" [(ngModel)]="initialFilters.containsFromLeft$policyNumber">
    </mat-form-field>

    <mat-form-field class="receivables-import-row-list-filter"
    ><mat-label>Kwota należności od</mat-label>
      <input matInput placeholder="Kwota należności od" name="gte$amountDue" [(ngModel)]="initialFilters.gte$amountDue">
    </mat-form-field>

    <mat-form-field class="receivables-import-row-list-filter">
      <mat-label>Kwota należności do</mat-label>
      <input matInput placeholder="Kwota należności do" name="lte$amountDue" [(ngModel)]="initialFilters.lte$amountDue">
    </mat-form-field>

    <app-datepicker
      class="receivables-import-row-list-filter"
      label="Data wymagalności od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$paymentDate" name="gte$paymentDate"
    ></app-datepicker>

    <app-datepicker
      class="receivables-import-row-list-filter"
      label="Data wymagalności do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$paymentDate" name="lte$paymentDate"
    ></app-datepicker>

    <app-datepicker
      class="receivables-import-row-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$conclusionAt" name="gte$conclusionAt"
    ></app-datepicker>

    <app-datepicker
      class="receivables-import-row-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$conclusionAt" name="lte$conclusionAt"
    ></app-datepicker>

    <app-dict
      [multiple]="true" label="Status"
      class="receivables-import-row-list-filter"
      dictType="receivables_import_row_status"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <mat-form-field class="receivables-import-row-list-filter">
      <mat-label>Identyfikator</mat-label>
      <input matInput placeholder="Identyfikator" name="contains$ofwcaIdNumber" [(ngModel)]="initialFilters.contains$ofwcaIdNumber">
    </mat-form-field>

    <mat-form-field class="receivables-import-row-list-filter">
      <mat-label>Nazwa klienta</mat-label>
      <input matInput placeholder="Nazwa klienta" name="contains$customerName" [(ngModel)]="initialFilters.contains$customerName">
    </mat-form-field>


    <mat-form-field
      *ngIf="!embeddedView"
      appearance="standard" class="receivables-import-row-list-filter">
      <mat-label> Polisa w saldzie</mat-label>
      <mat-select [(ngModel)]="initialFilters.haveBalance" name="haveBalance">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="0">Tak</mat-option>
        <mat-option [value]="1">Nie</mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field
      *ngIf="!embeddedView"
      class="receivables-import-row-list-filter">
      <mat-label>Nazwa pliku</mat-label>
      <input matInput placeholder="Nazwa pliku" name="fileName" [(ngModel)]="initialFilters.fileName">
    </mat-form-field>


  </form>

  <div *ngIf="showFilter" class="receivables-import-row-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()"> <mat-icon>download</mat-icon> Pobierz raport</button>
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div *ngIf="!showFilter" class="receivables-import-row-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()"> <mat-icon>download</mat-icon> Pobierz raport</button>
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef > TU
      <td mat-cell *matCellDef="let element">
          {{element.insuranceCompany.name}}  <br>{{element.import?.importer?.name}}
    </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header="createdAt">Data dodania
      <td mat-cell *matCellDef="let element">
       {{element.receivablesJob?.requestedAt| date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="changeToPaidAt">
      <th mat-header-cell *matHeaderCellDef > Data rozliczenia
      <td mat-cell *matCellDef="let element">
        {{ element.status.key === RECEIVABLES_IMPORT_ROW_STATUS_PAID ?( element.changeToPaidAt| date:'y-MM-dd') : '-'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        {{element.registrationPartner?.partnerFullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
       {{element.registrationPartner?.ofwcaFullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
          {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef > Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/naleznosci/lista/szczegoly', element.uuid]">
          {{element.policyNumber ? element.policyNumber : 'Brak numeru'}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Kwota należności </th>
      <td mat-cell *matCellDef="let element">
        {{(element.amountDue !== null ? element.amountDue : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>


    <ng-container matColumnDef="paymentAt">
      <th mat-header-cell *matHeaderCellDef> Data wymagalności  </th>
      <td mat-cell *matCellDef="let element">
        {{element.paymentDate | date:'y-MM-dd '}}
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

